import * as Sentry from "@sentry/react";
import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import { StartClient } from "@tanstack/react-start";
/// <reference types="vinxi/types/client" />
import { hydrateRoot } from "react-dom/client";
import { createIDBPersister } from "./lib/client/queryPersister";
import { createRouter, queryClient } from "./router";

const router = createRouter();
const idbPersister = createIDBPersister();

Sentry.init({
	dsn: import.meta.env.VITE_SENTRY_DSN,
	enabled: import.meta.env.PROD,
	integrations: [
		Sentry.browserTracingIntegration(),
		Sentry.tanstackRouterBrowserTracingIntegration(router),
	],
	tracesSampleRate: 0.5,
});

hydrateRoot(
	document,
	<PersistQueryClientProvider
		client={queryClient}
		persistOptions={{
			persister: idbPersister,
			maxAge: 1000 * 60 * 60 * 24 * 7, // 1 week
		}}
	>
		<StartClient router={router} />
	</PersistQueryClientProvider>,
);
